import {ApplicationEntity} from "@/model/entity/application-entity"
import { Type } from "class-transformer"
import { Country } from "../country/country"

export class ShipmentReturn extends ApplicationEntity {
  name: string | null

  name2: string | null

  city: string | null

  postalCode: string | null

  @Type(() => Country)
  country?: Country

  street: string | null

  houseNumber: string | null

  phone: string | null

  constructor(
    name: string | null = null,
    name2: string | null = null,
    city: string | null = null,
    postalCode: string | null = null,
    country?: Country,
    street: string | null = null,
    houseNumber: string | null = null,
    phone: string | null = null,
    id?: number
  ) {
    super(id)
    this.name = name
    this.name2 = name2
    this.city = city
    this.postalCode = postalCode
    this.country = country
    this.street = street
    this.houseNumber = houseNumber
    this.phone = phone
  }
}
